var pendingBoxHandler = () => {

    // drawer
    document.querySelectorAll('.pending-box-close').forEach(btn => {
        const drawer = btn.closest('.drawer');
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            drawer.classList.remove('drawer-visible');
        });
    });

    // modal
    remoteModalHandler('#drawerBoxContent', false);
    localModalHandler('#drawerBoxContent');

}